import type { FaireProductEntity } from "../../entity_types/product";

export const p_rmqsym6mvr: FaireProductEntity = {
  token: "p_rmqsym6mvr",
  type: "product",
  name: "Sequin Bat Halloween Tutu Skirt - Kids Clothing",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/ad1003574aaf889f89172407b8bd52460d2c1285ff3048d4c9be0bb081b4df3d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e408d5dfb127a7b939c3aac83cb2cfbbe75f76390082c9785444dbd42b47eefe.jpeg",
    "https://cdn.faire.com/fastly/31d0639c199122b4480ca0db20c19516865893144234ffe0496bdbf403ba4241.jpeg",
    "https://cdn.faire.com/fastly/cbeaaa23bc63e3c4065459f13787f2da9025ea16407fd40c4982de5a87e9fc17.jpeg",
    "https://cdn.faire.com/fastly/76f74d5e0c30adb2dc0e8044b8acf98b23fbf53e6b7ec9b7ac824d31ef2d5d26.jpeg",
    "https://cdn.faire.com/fastly/7f999b77781f6f1bc85e1dc993022e74f8ea3f040aff2919758f3557cac9567e.jpeg",
    "https://cdn.faire.com/fastly/3a1eaef428d0e8dddd4d2fcff2660e2cd4303a1ff73b8b5c72960236fcdfe180.jpeg",
  ],
  priceDollars: 18,
  description:
    "Twirl into spooky season with this enchanting tutu featuring shimmering bat details and a sprinkle of sparkle that's made for little girls who love their Halloween with a touch of magic.\n\nFeatures:\n * Lavender tulle accented with black sequin bats and silver glitter pin dots \n * Cotton lining \n * Silver shimmer elastic waistband \n * Care: Hand wash and line dry \n\nThe Sweet Wink difference:\n * Super soft tulle that doesn’t scratch or itch \n * Cotton lining provides extra coverage and comfort \n * “Shed-free” embellishments ensure glitter does not sprinkle around the house ",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:34:31.963Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
